import SurveyPage from './survey.container';

export default SurveyPage;